
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import {readFormsFile} from '@/store/main/getters';
import {dispatchGetFormsFile} from '@/store/main/actions';
import pdf from 'vue-pdf';
import LZString from 'lz-string';


@Component({
  components: {pdf},
})
export default class PdfPreviewDialog extends Vue {
  @Prop()
  public pdfDataId!: number;
  @Prop()
  public formValueId?: number;

  private pageCount: any = 0;
  private currentPage: any = 0;
  private pdfLocalData: any = '';

  private dialog: boolean = false;
  private imageType: string = '';

  private imageTypeValid: any = ['image/jpeg', 'image/png', 'image/jpg'];

  // public async mounted() {}

  @Watch('dialog')
  private async showPdfData() {
    if (this.dialog && this.pdfDataId > 0) {
      if (!this.pdfData) {
        await dispatchGetFormsFile(this.$store, this.pdfDataId);
      }
      await this.readFileAsURL(this.pdfData).then((result) => this.pdfLocalData = result);
    }
  }

  private get pdfData() {
    return readFormsFile(this.$store)(+this.pdfDataId);
  }



  private async readFileAsURL(file) {

    if (!file) { return; }
    const descompressed = await LZString.decompressFromUTF16 (file.data_base64);

    if (await this.imageTypeValid.find((e) => e === file.type)) {
      this.imageType = file.type;
    }

    return await new Promise((resolve, reject) => {
      const r = fetch(descompressed)
          .then((res) => res.blob())
          .then((blob) => {
            return URL.createObjectURL(blob);
          });
      resolve(r);
    });

    const urlFile = await fetch(file.data_base64)
        .then((res) => res.blob())
        .then((blob) => {
          // const link = document.createElement('a');
          // link.href = URL.createObjectURL(blob);
          // link.download = file.name;
          // link.click();
          // return URL.revokeObjectURL(link.href);
          // return new File([blob], file.name, {type: file.type});
        });
  }
}
